import Icon from "~/components/Icon"
import iconsList from "./icons.json"

export default {
    install(app) {
        app.component("VIcon", Icon)
        Icon.register(iconsList)
    },
}
